import { DndContext } from "@dnd-kit/core";
import { observer } from "mobx-react-lite";
import Parse, { Role } from "parse";
import * as React from "react";
import { useEffect, useState } from "react";
import { saveTicket } from "../../..";
import { _Role } from "../../../../../js/parsegenerated";
import { SaveTicketValuesWithFullMeta } from "../../../creation/types/SaveTicketValues";
import { KanbanContext } from "../../context/KanbanContext";
import { useDragHandler } from "../../hooks/useDragHandler";
import { DragHandlerData } from "../../types/Draggable";
import { KanbanColumn } from "../KanbanColumn";
import { KanbanLayout } from "../KanbanLayout";

type Props = {};

export const RoleView = observer((props: Props) => {
  const [roles, setRoles] = useState<Role[]>([]);
  const kanbanManager = React.useContext(KanbanContext);

  const dragHandler = useDragHandler(handleMoveRole);

  useEffect(() => {
    new Parse.Query(Role).find().then((role) => {
      setRoles(role);
    });
  }, []);

  async function handleMoveRole(data: DragHandlerData) {
    try {
      const assignedUsers = await data.ticketData.ticket
        .relation("assignedusers")
        .query()
        .find();
      const assignedRoles = await data.ticketData.ticket
        .relation("assignedroles")
        .query()
        .find();
      const assignedToUsers: Array<{ type: "role" | "user"; id: string }> =
        assignedUsers.map((user) => ({ type: "user", id: user.id }));
      const assignedToRoles: Array<{ type: "role" | "user"; id: string }> =
        assignedRoles
          .filter((role) => role.id !== data.origin)
          .map((role) => ({ type: "role", id: role.id }));
      assignedToRoles.push({ type: "role", id: data.destination });

      const saveValues: SaveTicketValuesWithFullMeta = {
        existingTicketId: data.ticketData.ticket.id,
        assignedTo: [...assignedToUsers, ...assignedToRoles],
      };
      await saveTicket(saveValues);

      kanbanManager.reload(data.destination);
      kanbanManager.reload(data.origin);
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <div>
      <DndContext onDragEnd={dragHandler}>
        <KanbanLayout>
          {roles.map((r: _Role) => {
            return (
              <KanbanColumn
                id={r.id}
                key={r.id}
                title={r.get("label")}
                ticketManagerConfig={{
                  filters: {
                    role: { attribute: "role", value: r.id },
                  },
                }}
              />
            );
          })}
        </KanbanLayout>
      </DndContext>
    </div>
  );
});
